import store from '../state/store'

export function addLogs(data) {
  let logText = localStorage.getItem('logs') || []
  // Add new "line" of log data
  logText = logText.push(data)
  localStorage.setItem('logs', logText)
}
export function logDate() {
  const date = new Date()
  return date
    .toISOString()
    .slice(0, 19)
    .replace('T', ' ')
}
export function tokenExpiryTrack(minutes) {
  let expiryTime = minutes
  let expiryInterval = setInterval(() => {
    if (expiryTime < 0) {
      clearInterval(expiryInterval)
    }
    if (expiryTime === 2) {
      store.dispatch('auth/getNewToken')
    }
    expiryTime -= 1
  }, 60000)
}
// {
//   "UserId": 5,
//   "Message": "Time out login user.",
//   "Description": "timeout 400 api",
//   "LogDateTime": "2023-06-28 21:21:21.021"
// }
